
import BaseObject from '../../base/base_object';
import {TOKEN_PROPERTIES} from './oauth_const';
import Store from '../../utils/store';
import {TimeSpan} from "@sparkware/app-utils";

export default class InactivityTimeoutSettingsPersister extends BaseObject {
    static CLASS = 'InactivityTimeoutSettingsPersister';

    _getServiceFactoryFunc = null;
    _defaultAccessTokenLifetime = null;
    _accessTokenLifeTimeForRegulation = null;
    _minAccessTokenLifeTime = null;
    _maxAccessTokenLifeTime = null;

    init(params) {
        this._getServiceFactoryFunc = params.getServiceFactoryFunc;
        this._defaultAccessTokenLifetime = TimeSpan.parse(params.defaultAccessTokenLifetime);
        this._accessTokenLifeTimeForRegulation = params.accessTokenLifeTimeForRegulation || {};
        this._minAccessTokenLifeTime = TimeSpan.parse(params.minAccessTokenLifeTime);
        this._maxAccessTokenLifeTime = TimeSpan.parse(params.maxAccessTokenLifeTime);
    }

    get serviceFactory() {
        return this._getServiceFactoryFunc();
    }

    _getDefaultAccessTokenLifetime() {
        let currentRegulationCode = this.serviceFactory.regulationService().getRegulationCode();

        if (this._accessTokenLifeTimeForRegulation[currentRegulationCode]) {
            return TimeSpan.parse(this._accessTokenLifeTimeForRegulation[currentRegulationCode]);
        } else {
            return this._defaultAccessTokenLifetime;
        }
    }

    setCustomAccessTokenLifeTime(timeSpan) {
        if (TimeSpan.areEquals(this._getDefaultAccessTokenLifetime(), timeSpan)) {
            Store.del(TOKEN_PROPERTIES.OAUTH_CUSTOM_SESSION_TIMEOUT);
        } else {

            Store.set(TOKEN_PROPERTIES.OAUTH_CUSTOM_SESSION_TIMEOUT, this._limitCustomAccessTokenLifeTime(timeSpan).toString());
        }
    }

    tryGetCustomAccessTokenLifeTime() {
        let timeSpanAsString = Store.get(TOKEN_PROPERTIES.OAUTH_CUSTOM_SESSION_TIMEOUT, null);
        if (!timeSpanAsString) {
            return null;
        }
        try {
            let timeSpan = TimeSpan.parse(timeSpanAsString);
            return this._limitCustomAccessTokenLifeTime(timeSpan);
        }
        catch (err) {
            // in case it fails we don't want to fail everything because of this
            this.logger.error('tryGetCustomAccessTokenLifeTime failed! ', err);
            return null;
        }
    }

    getAccessTokenLifeTime() {
        let timeSpan = this.tryGetCustomAccessTokenLifeTime();
        if (timeSpan) {
            return timeSpan;
        }

        return this._getDefaultAccessTokenLifetime();
    }

    getMinAccessTokenLifeTime() {
        return this._minAccessTokenLifeTime;
    }

    getMaxAccessTokenLifeTime() {
        return this._maxAccessTokenLifeTime;
    }

    getPossibleAccessTokenLifeTimeValues() {
        let result = [];
        let minValueInMinutes = this._minAccessTokenLifeTime.totalMinutes;
        let maxValueInMinutes = this._maxAccessTokenLifeTime.totalMinutes;
        for (let i = minValueInMinutes; i <= maxValueInMinutes; i = i + 10) {
            result.push(TimeSpan.fromMinutes(i));
        }
        return result;
    }


    _limitCustomAccessTokenLifeTime(timeSpan) {
        if (timeSpan.totalMilliseconds > this._maxAccessTokenLifeTime.totalMilliseconds) {
            return this._maxAccessTokenLifeTime;
        } else if (timeSpan.totalMilliseconds < this._minAccessTokenLifeTime.totalMilliseconds) {
            return this._minAccessTokenLifeTime;
        } else {
            return timeSpan;
        }
    }
}